export default () => ({
  otp: '',
  size: 4,

  get isValid () {
    return this.otp.length === this.size
  },

  onInputClick ({ target }) {
    if (target.type === 'tel') {
      target.setSelectionRange(0, target.value.length)
    }
  },

  onInputFocus ({ target }) {
    if (target.type === 'tel') {
      target.setSelectionRange(0, target.value.length, 0)
    }
  },

  onInputChange ({ target }) {
    const { input1, input2, input3, input4 } = this.$refs
    const value = target.value.replace(/[^0-9]/g, '')
    let index = target.tabIndex

    if (value.length < this.size) {
      target.value = value.substring(0, 1)
    } else {
      input1.value = value.substring(0, 1)
      input2.value = value.substring(1, 2)
      input3.value = value.substring(2, 3)
      input4.value = value.substring(3, 4)
      index = this.size
    }

    this.otp = [input1.value, input2.value, input3.value, input4.value].join('')

    if (!target.value) return

    if (index < this.size) {
      this.$refs[`input${index + 1}`].focus()
    } else {
      this.$nextTick(() => {
        const { submit } = this.$refs

        submit.focus()
        submit.click()
      })
    }
  },

  onSubmit (event) {
    if (!this.isValid && event.submitter.value !== 'resend') event.preventDefault()
  }
})
